import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { articles } from "@/mocks/articles";

const articleImages: Record<string, string> = {
  "itaobuyspreadsheet-2026-guide": "https://readdy.ai/api/search-image?query=Clean%20workspace%20with%20laptop%20displaying%20spreadsheet%20and%20fashion%20product%20photos%2C%20dark%20walnut%20desk%2C%20natural%20daylight%2C%20editorial%20lifestyle%20photography%2C%20warm%20tones%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-guide-jun27&orientation=landscape",
  "how-to-buy-from-china-safely": "https://readdy.ai/api/search-image?query=Shield%20and%20lock%20security%20concept%20with%20shopping%20elements%2C%20clean%20light%20surface%2C%20soft%20daylight%2C%20trustworthy%20editorial%20photography%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-safety-jun27&orientation=landscape",
  "agent-comparison-tips": "https://readdy.ai/api/search-image?query=Two%20shopping%20platforms%20side%20by%20side%20comparison%20concept%2C%20clean%20surface%2C%20soft%20daylight%2C%20editorial%20photography%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-compare-jun27&orientation=landscape",
  "itaobuyspreadsheet-vs-superbuy": "https://readdy.ai/api/search-image?query=Split%20screen%20spreadsheet%20versus%20traditional%20shopping%20platform%20concept%2C%20clean%20background%2C%20soft%20lighting%2C%20editorial%20comparison%2C%20no%20text&width=1200&height=600&seq=article-hero-vs-superbuy-jun27&orientation=landscape",
  "cheapest-way-buy-from-china": "https://readdy.ai/api/search-image?query=Money%20savings%20concept%20with%20shipping%20parcels%20and%20coins%2C%20clean%20surface%2C%20natural%20daylight%2C%20editorial%20photography%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-cheapest-jun27&orientation=landscape",
  "is-itaobuyspreadsheet-safe": "https://readdy.ai/api/search-image?query=Security%20shield%20with%20checkmark%20and%20shopping%20elements%2C%20clean%20light%20surface%2C%20daylight%2C%20trustworthy%20editorial%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-safe-jun27&orientation=landscape",
  "save-money-international-shipping": "https://readdy.ai/api/search-image?query=International%20shipping%20boxes%20with%20world%20map%20concept%2C%20clean%20surface%2C%20daylight%2C%20logistics%20editorial%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-shipping-jun27&orientation=landscape",
  "beginners-guide-taobao-spreadsheet": "https://readdy.ai/api/search-image?query=Hands%20holding%20smartphone%20showing%20shopping%20app%2C%20clean%20surface%2C%20daylight%2C%20beginner%20friendly%20lifestyle%2C%20no%20face%2C%20no%20text&width=1200&height=600&seq=article-hero-beginner-jun27&orientation=landscape",
  "itaobuyspreadsheet-pricing": "https://readdy.ai/api/search-image?query=Price%20tags%20and%20calculator%20with%20products%2C%20clean%20surface%2C%20daylight%2C%20transparent%20pricing%20concept%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-pricing-jun27&orientation=landscape",
  "top-products-itaobuyspreadsheet": "https://readdy.ai/api/search-image?query=Curated%20trending%20fashion%20products%20seasonal%20display%2C%20clean%20surface%2C%20daylight%2C%20editorial%20photography%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-trending-jun27&orientation=landscape",
  "agent-verification-network": "https://readdy.ai/api/search-image?query=Network%20connection%20with%20verification%20checkmarks%20concept%2C%20clean%20surface%2C%20daylight%2C%20editorial%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-network-jun27&orientation=landscape",
  "spreadsheet-vs-agent-shopping": "https://readdy.ai/api/search-image?query=Split%20comparison%20spreadsheet%20versus%20agent%20shopping%20concept%2C%20clean%20surface%2C%20daylight%2C%20editorial%2C%20no%20text%2C%20professional&width=1200&height=600&seq=article-hero-vs-agent-jun27&orientation=landscape",
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? articles[slug] : undefined;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [slug]);

  if (!article) {
    return (
      <>
        <Navbar />
        <main>
          <section className="w-full pt-40 pb-20 bg-background-50 text-center">
            <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
              <h1 className="text-3xl font-heading font-bold text-foreground-950 mb-4">Article Not Found</h1>
              <p className="text-foreground-600 mb-6">The guide you are looking for does not exist or has been moved.</p>
              <Link
                to="/shopping-guide"
                className="inline-flex items-center gap-2 bg-foreground-950 hover:bg-foreground-800 text-background-50 font-semibold px-8 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                Browse All Guides
              </Link>
            </div>
          </section>
        </main>
        <Footer />
      </>
    );
  }

  const imageUrl = articleImages[slug!] || articleImages["itaobuyspreadsheet-2026-guide"];

  return (
    <>
      <Navbar />
      <main>
        <article>
          <section className="w-full pt-32 pb-16 md:pt-40 md:pb-20 bg-background-50">
            <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
              <div className="flex items-center gap-2 mb-6">
                <Link
                  to="/"
                  className="text-sm text-secondary-600 hover:text-secondary-700 font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
                >
                  <i className="ri-arrow-left-line"></i>
                  Home
                </Link>
                <span className="text-foreground-400">/</span>
                <Link
                  to="/shopping-guide"
                  className="text-sm text-secondary-600 hover:text-secondary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  Shopping Guide
                </Link>
                <span className="text-foreground-400">/</span>
                <span className="text-sm text-foreground-500 truncate max-w-[200px]">{article.title}</span>
              </div>

              <div className="rounded-2xl overflow-hidden mb-8">
                <img
                  src={imageUrl}
                  alt={article.title}
                  className="w-full aspect-[2/1] object-cover"
                />
              </div>

              <span className="text-xs font-semibold text-secondary-600 uppercase tracking-widest">
                Shopping Guide
              </span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mt-3 mb-4 leading-tight">
                {article.title}
              </h1>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                {article.subtitle}
              </p>
              <div className="flex items-center gap-4 mt-6 pb-8 border-b border-background-200/70">
                <span className="text-xs text-foreground-500">Last updated: {article.date}</span>
                <span className="text-xs text-foreground-500">•</span>
                <span className="text-xs text-foreground-500">{article.readTime}</span>
              </div>
            </div>
          </section>

          <section className="w-full py-10 md:py-14 bg-background-50">
            <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
              {article.sections.map((section, idx) => (
                <div key={idx} className="mb-10 md:mb-14">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                    {section.heading}
                  </h2>
                  <div className="text-base text-foreground-700 leading-relaxed space-y-4">
                    {section.content.split("\n\n").map((paragraph, pIdx) => (
                      <p key={pIdx}>{paragraph}</p>
                    ))}
                  </div>
                </div>
              ))}

              <div className="mt-12 pt-10 border-t border-background-200/70">
                <div className="bg-background-100 rounded-2xl p-6 md:p-8 text-center">
                  <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
                    Ready to Start Shopping?
                  </h3>
                  <p className="text-sm text-foreground-600 mb-6 max-w-md mx-auto">
                    Browse curated spreadsheets across 14 product categories and find the best deals from verified China shopping agents.
                  </p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <a
                      href="https://kaspreadsheet.com"
                      target="_blank"
                      rel="noopener nofollow"
                      className="bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-8 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
                    >
                      itaobuy sheet
                    </a>
                    <Link
                      to="/"
                      className="bg-foreground-950 hover:bg-foreground-800 text-background-50 font-semibold px-8 py-3 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
                    >
                      Back to Home
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: article.title,
            description: article.subtitle,
            image: imageUrl,
            datePublished: "2026-06-27",
            dateModified: "2026-06-27",
            author: { "@type": "Organization", name: "itaobuy.cam" },
            publisher: { "@type": "Organization", name: "itaobuy.cam", logo: { "@type": "ImageObject", url: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg" } },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": `https://itaobuy.cam/article/${slug}`
            },
            inLanguage: "en-US",
          }),
        }}
      />
    </>
  );
}